import React from "react";

const TrustStatement = () => {
  return (
    <section className="security_Real_Time trust-statement-section" id="trust-statement">
      <div className="trust-statement-container">
        <div className="trust-line top-line" />

        <div className="trust-content">
          <h2 className="trust-title">
            <span className="trust-word">Security that works for real teams</span>
          </h2>

          <p className="trust-description">
            Every day, teams handle deadlines, files, discussions, and sensitive
            information. Security shouldn't slow you down. Simplifyte keeps your
            work protected with safe storage, smart access controls, and
            reliable systems—so you can focus on what matters.
          </p>
        </div>

        <div className="trust-line bottom-line" />
      </div>
    </section>
  );
};

export default TrustStatement;
